import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  props: {
    info: Object
  },
  computed: {
    ...mapState({
      State: state => state,
      loginInfo: state => state.loginInfo
    })
  },
  data() {
    return {
      setInfo: {
        mute: false,
        noCamera: false,
        noAudio: false,
        useCamera: false
      },
      redTips: '',
      redTips1: '',
      nickName: '',
      organization: '',
      audioLoaded: false,
      videoLoaded: false,
      selectCameraId: '',
      selectMicroId: '',
      videoList: [],
      microList: []
    };
  },
  watch: {
    nickName(val) {
      // 过滤emoji表情
      this.nickName = this.nickName.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');
      if (val) this.redTips = false;
    },
    organization(val) {
      if (val) this.redTips1 = false;
    }
  },
  created() {
    this.info.show = true;
    this.info.userInfo = this.info.userInfo || {};
    if (this.info.userInfo.nickName) {
      this.nickName = this.info.userInfo.nickName;
    } else {
      this.nickName = this.loginInfo.firstName || this.loginInfo.userName || this.loginInfo.email || '';
    }
    if (this.info.userInfo.organization) {
      this.organization = this.info.userInfo.organization;
    }
    Bus.$on('hasVideo', flag => {
      this.State.hasVideo = flag;
    });
    Bus.$on('hasAudio', flag => {
      this.State.hasAudio = flag;
    });
    Bus.$on('initDevices', obj => {
      this.videoLoaded = obj.videoLoaded;
      this.audioLoaded = obj.audioLoaded;
      this.videoList = obj.videoList;
      this.microList = obj.microList;
      this.selectMicroId = obj.selectMicroId;
      this.selectCameraId = obj.selectCameraId;
    });
  },
  methods: {
    changeDevice(obj) {
      handleLocalStorage('set', obj.type, obj.deviceId);
    },
    TurnTips(flag, tag) {
      // 无摄像头
      let msg = '';
      if (tag === 'camera' && !this.State.hasVideo) {
        msg = 'No access';
      } else {
        const onOroff = flag ? this.$t('operationBtn.on') : this.$t('operationBtn.off');
        msg = `${onOroff} ${tag}`;
      }
      return msg;
    },
    blurFn(type) {
      setTimeout(() => {
        if (type == 'nickName' && !this.nickName.replace(/(^\s*)|(\s*$)/g, '')) {
          this.redTips = this.$t('commonFunction.nameRequired');
        }
        if (type == 'corporation' && !this.organization) {
          this.redTips1 = this.$t('commonFunction.corporationRequired');
        }
      }, 300);
    },
    setBtn(type, btn) {
      if (type === 'noCamera' && !this.State.hasVideo) {
        return;
      }
      if (type === 'noAudio' && !this.State.hasAudio) {
        return;
      }
      this.setInfo[type] = btn;
    },
    save() {
      this.nickName = this.State.partyJoinInfo.channelMode != 1 ? this.nickName.replace(/(^\s*)|(\s*$)/g, '') : this.nickName;
      let data = [];
      this.setInfo.noCamera = !this.State.hasVideo || this.setInfo.noCamera;
      this.setInfo.noAudio = !this.State.hasAudio || this.setInfo.noAudio;
      this.setInfo.noHaveCamera = !this.State.hasVideo;
      this.setInfo.useCamera = this.State.hasVideo ? '1' : '3';
      if (!this.info.hideBtn) {
        data = [{
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'nickName',
          value: this.nickName,
          notify: true,
          initiator: this.info.userInfo.userRtilCode
        }, {
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'mute',
          value: this.setInfo.mute,
          notify: true,
          initiator: this.info.userInfo.userRtilCode
        }, {
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'noCamera',
          value: this.setInfo.noCamera,
          notify: true,
          initiator: this.info.userInfo.userRtilCode
        }, {
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'useCamera',
          value: this.setInfo.useCamera,
          notify: true,
          initiator: this.info.userInfo.userRtilCode
        }, {
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'noAudio',
          value: this.setInfo.noAudio,
          notify: true,
          initiator: this.info.userInfo.userRtilCode
        }, {
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'noHaveCamera',
          value: this.setInfo.noHaveCamera,
          notify: true,
          initiator: this.info.userInfo.userRtilCode
        }];
      } else {
        data = [{
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'nickName',
          value: this.nickName,
          notify: true,
          initiator: this.info.userInfo.userRtilCode
        }];
      }
      if (this.$route.name == 'reporterParticipate' || this.$route.name == 'coordinator' || this.$route.name === 'newCoordinator') {
        data.push({
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'organization',
          value: this.organization,
          notify: true,
          initiator: this.info.userInfo.userRtilCode
        });
      }
      if (!this.nickName && this.State.partyJoinInfo.channelMode != 1) {
        this.blurFn('nickName');
      }
      if (!this.nickName && this.State.partyJoinInfo.channelMode != 1) return;
      if (this.info.userInfo.rtilCode) {
        this.axios.post('/partyline-backend/behavior/noLogin/setList', data).then(res => {
          if (res.data.errorCode === '0x0') {
            this.info.show = false;
            if (this.info.userInfo.userRtilCode && this.info.userInfo.userRtilCode != this.info.userInfo.rtilCode) {
              // host修改与会者的name
              if (this.$route.name == 'coordinator' || this.$route.name === 'newCoordinator') {
                if (!this.info.hideBtn) {
                  this.$message.success(this.$t('startNewParty.participantSettingSuccessful'));
                } else {
                  this.$message.success(this.$t('copy.rename'));
                }
              } else {
                this.$message.success(this.$t('startNewParty.participantNameSuccessful'));
              }
            } else {
              if (!this.info.hideBtn) {
                this.$message.success(this.$t('startNewParty.participantSettingSucceTips'));
              } else {
                this.$message.success(this.$t('copy.rename'));
              }
            }
            this.$emit('setNickName', {
              ...this.setInfo,
              nickName: this.nickName,
              organization: this.organization
            });
            this.$emit('setDefaultDevice');
          } else {
            this.redTips = res.data.errorInfo;
          }
        });
      } else {
        this.$message.success(this.$t('remainWords.setSuccess'));
        this.info.show = false;
        this.$emit('setNickName', data);
        this.$emit('setDefaultDevice');
      }
    },
    cancelFn() {
      this.info.show = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    Bus.$off('hasVideo');
    Bus.$off('hasAudio');
    Bus.$off('initDevices');
  }
};